

















































import { Vue, Component } from 'vue-property-decorator';
import { RegisterRequest } from '../services/auth';

@Component
export default class Register extends Vue {
  form: RegisterRequest = {
    username: '',
    email: '',
    password: ''
  };

  async submit() {
    await this.$store.dispatch('auth/registerUser', this.form);
    this.$router.push({ name: 'home' });
  }

  get errors() {
    return this.$store.getters['auth/errors'];
  }
}
